@if (call.isOpen()) {
  <div
    class="relative z-40 flex w-full items-center justify-between gap-4 bg-gray-900 px-6 py-3">
    <div class="flex items-center gap-3">
      <button
        type="button"
        class="rounded-lg border border-gray-200 bg-white px-4 py-2 text-sm font-medium text-primary-700 transition-colors hover:bg-gray-50"
        (click)="openProtocols()">
        Protocols
      </button>
      <button
        type="button"
        class="rounded-lg border border-gray-200 bg-white px-4 py-2 text-sm font-medium text-primary-700 transition-colors hover:bg-gray-50"
        (click)="openHandout()">
        Handout
      </button>
      <button
        type="button"
        class="rounded-lg border border-gray-200 bg-white px-4 py-2 text-sm font-medium text-primary-700 transition-colors hover:bg-gray-50"
        (click)="openShareLabResults()">
        Share lab results
      </button>
    </div>

    <div class="flex items-center gap-3">
      <button
        type="button"
        class="rounded-lg border border-gray-200 bg-white px-4 py-2 text-sm font-medium text-primary-700 transition-colors hover:bg-gray-50"
        (click)="openCreateInvoice()">
        Create invoice
      </button>
      <icaredx-dropdown-menu
        data-testid="complete-encounter-actions"
        [menuItems]="completeEncounterMenu"
        [triggerClass]="completeTriggerClass"
        (actionEmitter)="onCompleteEncounterAction($event)">
        Complete Encounter
        <mat-icon svgIcon="chevron-down" class="ml-2 h-4! w-4! rotate-180" />
      </icaredx-dropdown-menu>
    </div>
  </div>
}
